import { Colors } from "risa-oasis-ui_v2";
import { InfoIcon } from "../../../svg/info-icon";

const NoQuestionsFound = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2">
      <InfoIcon height="24" width="24" stroke={Colors.tertiaryRed3} />
      <span className="text-h10">No questions found for this order.</span>
    </div>
  );
};

export default NoQuestionsFound;
